import ButtonPrimary from 'components/ButtonPrimary'
import React from 'react'
import './index.scss'
import TextTitleCondensed from 'components/TextTitleCondensed.js'

/**
 * @param isLoading
 * @param onClick
 * @param children
 * @param label
 * @param loadingLabel
 * @param rest
 * @returns {Element}
 * @constructor
 */
function ButtonLoader ({
  isLoading,
  onClick,
  children,
  label,
  loadingLabel,
  ...rest
}) {
  let buttonOnClick = onClick
  let buttonContent = children || label

  if (isLoading) {
    buttonOnClick = null
    const loadingText = loadingLabel || 'Loading...'
    buttonContent = (
      <>
        <span className='button-loader-spinner' />
        {' '}
        <TextTitleCondensed
          c='#ffffff'
          fs='18px'
          fw='760'
        >
          {loadingText}
        </TextTitleCondensed>
      </>
    )
  }

  return (
    <ButtonPrimary
      {...rest}
      onClick={buttonOnClick}
    >
      {buttonContent}
    </ButtonPrimary>
  )
}

export default ButtonLoader
